function appendExtendElement() {
  const extendedItem = document.querySelector('.col--extended');

  if (window.innerWidth >= 1440) {
    const plansItems = document.querySelectorAll('.plans-table-item');
    if (plansItems.length > 0 && !extendedItem) {

      const firstPlansItem = plansItems[0];
      //Find an extended fields block
      const colExtended = firstPlansItem.querySelector('.col-extended');

      // Create a new table item with class 'col--extended'
      const fields = document.createElement('div');
      fields.className = 'plans-table-item col--extended col';

      //Select all extended fields titles
      const dataFields = colExtended.querySelectorAll('[data-field]');

      dataFields.forEach(function(dataField) {
        // Get the value of the data-field attribute
        const value = dataField.getAttribute('data-field');

        // Create a new wrapper for each field value and add them to the 'col--extended'
        const valueDiv = document.createElement('p');
        valueDiv.className = 'field-title';
        valueDiv.textContent = value;
        fields.appendChild(valueDiv);
      });

      firstPlansItem.parentNode.insertBefore(fields, firstPlansItem);
    }
  } else {
    if (extendedItem) {
      extendedItem.parentNode.removeChild(extendedItem);
    }
  }
}

document.addEventListener('DOMContentLoaded', appendExtendElement);

window.addEventListener('resize', appendExtendElement);
